import { Component, OnInit, ViewChildren, ViewChild, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../user.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  showOtpComponent = true;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  public email: any;
  public first_name: any;
  public last_name: any;
  public mobile: number;
  public cnfmpassword: string;
  public password: string;
  public otp: any;
  public success: any;
  codeDropdown: any = ['+91', '+1'];
  country: any;

  t = { leftTime: 60 };
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @Output() resend_: EventEmitter<any> = new EventEmitter();
  form: FormGroup;
  verifyOtp: any;
  enable_btn: any;
  otp_resend: boolean = false;
  verify_btn_reopen: any;
  verify_btn_reopen_again: any;
  constructor(
    public toastr: ToastrService,
    public usr: UserService,
    public router: Router,

    private SpinnerService: NgxSpinnerService) {
    // console.log("const", this.t.leftTime);
  }
  ngOnInit(): void {
    // console.log("OnIn", this.t.leftTime);
  }

  onOtpChange(event) {
    this.verifyOtp = event;
  }

  send() {
    if (!this.first_name) {
      return this.toastr.error("First Name Is Empty")
    } else if (!this.last_name) {
      return this.toastr.error("Last Name Is Empty");
    } else if (!this.email) {
      return this.toastr.error("Email Is Empty");
    } else if (!this.country) {
      return this.toastr.error("Countrty Code Is Empty");
    } else if (!this.mobile) {
      return this.toastr.error("Mobile Is Empty");
    } else {
      let obj = {
        "mobile_num": this.mobile,
        "countrycode" : this.country
      }
      console.log(obj);
      // console.log("send", this.t);
      this.usr.otpSend(obj).subscribe((res: any) => {
        if (res.code === 200) {
          this.otp = res.OTP;
          setTimeout(() => {
            this.enable_btn = res.OTP;
          }, 60000);
          this.toastr.success(res.data);
        } else if (res.code === 402) {
          this.toastr.error(res.message);
        }
        else {
          this.toastr.error(res.message);
        }
      }, (err) => {
        this.toastr.error("err");
      });
    }
  }


  verify() {
    if (!this.verifyOtp) {
      return this.toastr.error("Please enter Otp")
    }
    else if (this.otp == this.verifyOtp) {
      this.success = this.otp;
      this.toastr.success("otp verified");
    } else {
      return this.toastr.error("Wrong Otp");
    }
  }

  resend() {
    this.resend_.emit('resend');
    this.t = { leftTime: 59 };

    if (!this.otp) {
      this.toastr.error("Please Verify First");
    } else {
      this.enable_btn = false;
      this.send();
    }
  }

  registerClose() {
    setTimeout(() => {
      this.router.navigate(['home']);
    }, 100);
  }
  reg() {
    if (!this.email) {
      this.toastr.error("Please fill email");
      return;
    } else if (!this.first_name) {
      this.toastr.error("Please fill first name");
      return;
    } else if (!this.last_name) {
      this.toastr.error("Please fill last name");
      return;
    } else if (!this.country) {
      return this.toastr.error("Please Select Country Code");
    } else if (!this.mobile) {
      this.toastr.error("Please fill Mobile");
      return;
    } else if (!this.password) {
      this.toastr.error("Please fill Password");
      return;
    } else if (!this.cnfmpassword) {
      this.toastr.error("Please fill Confirm Pasword");
      return;
    } else if (this.password != this.cnfmpassword) {
      this.toastr.error("Password Mismatch");
      return;
    }
    else {
      let data = {
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        mobile: `${this.mobile}`,
        password: this.password,
      };
      // console.log(data);
      this.SpinnerService.show();
      this.usr.signUp(data).subscribe((res: any) => {
        this.SpinnerService.hide();
        if (res.code === 200) {
          this.toastr.success(res.message);
          if (res.message === "User Details Already Exists...!") {
            this.email = "";
            this.password = "";
            this.cnfmpassword = "";
            this.first_name = "";
            this.last_name = "";
            this.mobile = null;
            this.router.navigate(['register']);
          } else {
            this.router.navigate(['/login']);
          }

        } else {
          this.toastr.error(res.message);
        }
        // console.log(res);
      },
        err => {
          console.log(err);
          this.toastr.error(err.message);
        }
      )
    }
  }

  onConfigChange() {
    this.showOtpComponent = false;
    this.otp = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }
}